import PropTypes from "prop-types";
import React from "react";

import { PropTypeShapes } from "../../../types";
import SingleFormDatePicker from "./SingleFormDatePicker";

const DateRangeDatePicker = ({ calendar, date, onDateChange, label, onToggleCalendarPicker, ...props }) => {
  return (
    <SingleFormDatePicker
      value={date}
      onChange={onDateChange}
      calendar={calendar}
      onToggleCalendarPicker={onToggleCalendarPicker}
      title={label}
      fieldLabel={label}
      emptyLabel="Infinite"
      {...props}
    />
  );
};

DateRangeDatePicker.propTypes = {
  calendar: PropTypeShapes.calendar.isRequired,
  date: PropTypeShapes.dateRelated,
  onDateChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  onToggleCalendarPicker: PropTypes.func
};

export default DateRangeDatePicker;
